import React from 'react';
import { RoundButton } from '../RoundButton';

const reportIcon = require('assets/route.svg');

export function RouteButton({ onPress }) {
  return (
    <RoundButton
      onPress={onPress}
      testID={'RouteButton'}
      image={reportIcon}
      color={'#4ccf26'}
    />
  );
}
